<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <div class="content-carousel">
      <ImageCarousel :theme="themeColor">
        <template #title>
          <heading
            v-if="hasTitle"
            class="title"
            desktop-size="size-5"
            mobile-size="size-5"
            :textField="fields.title"
            :tagField="headingSize"
            default-tag="h2"
          />
          <!-- Bit of a hack but otherwise it disables all the named slots
          if we don't return anything -->
          <div v-else />
        </template>
        <template #cta>
          <sc-link v-if="isEditMode" class="sc-link" :field="fields.link"/>
          <sh-button
            v-if="!isEditMode && linkHref"
            class="carousel-link"
            :naked="true"
            :[btnLinkKey]="linkHref"
            :target="linkTarget"
            :aria-label="linkHiddenText || linkText"
          >
            {{ linkText }}
          </sh-button>
        </template>
        <template  v-if="!isEditMode">
          <template v-for="tile in tiles">
            <component :key="tile.id" :is="tile.value" />
          </template>
        </template>
      </ImageCarousel>
      <sc-placeholder v-if="isEditMode" class="carousel-editor" :rendering="rendering" name="digital-house-content-carousel" />
    </div>
  </sc-render>
</template>

<script>

import { Text, Link, Placeholder } from '@sitecore-jss/sitecore-jss-vue'
import { ImageCarousel } from '@sohohouse/design-system'
import { createNamespacedHelpers } from 'vuex'

import { getButtonType } from '~/helpers/get-button-type'
import get from '~/helpers/get'
import { arrayUID } from '~/helpers/unique-id'

import ScRender from '../sc-render'
import Heading from '../heading'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')
const { mapGetters: mapEnvGetters } = createNamespacedHelpers('ui/environment')

export default {
  name: 'Carousel',

  props: {
    fields: {
      type: Object,
      default: () => ({})
    },

    rendering: {
      type: Object
    }
  },

  components: {
    ScRender,
    ImageCarousel,
    ScText: Text,
    ScLink: Link,
    ScPlaceholder: Placeholder,
    Heading
  },

  withPlaceholder () {
    return {
      placeholders: [
        {
          placeholder: 'digital-house-content-carousel',
          computedPropName: 'tilesPlaceholder'
        }
      ]
    }
  },

  computed: {
    ...mapJssGetters(['isEditMode']),
    ...mapEnvGetters(['isDarkTheme', 'themeColor']),

    headingSize () {
      return get(this.fields, 'headingSize', { value: 'H2' })
    },

    tiles () {
      return arrayUID(this.tilesPlaceholder)
    },

    linkHref () {
      return get(this.fields, 'link.value.href', '')
    },

    linkTarget () {
      return get(this.fields, 'link.value.target', '')
    },

    linkHiddenText () {
      return get(this.fields, 'link.value.data-hidden-text', '')
    },

    linkText () {
      return get(this.fields, 'link.value.text', '')
    },

    hasTitle () {
      return this.isEditMode || get(this.fields, 'title.value', false)
    },

    btnLinkKey () {
      return getButtonType(this.linkHref)
    }
  }
}
</script>

<style lang="scss" scoped>

.content-carousel {
  max-width: 100%;
  margin: $space-090 0;

  @include tablet() {
    margin: $space-110 0;
  }
}

.carousel-editor {
  width: 100%;
  display: flex;
  overflow-x: scroll;
  // to avoid extra carousel spaces in EE
  margin: -$space-120 $space-050 0;
}

</style>
